/* VEKA — carrito AJAX + interacciones de UI compartidas por el tema */
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var mobMenu = document.querySelector('[data-mobile-menu]');

  function openCart() { drawer && drawer.classList.add('open'); overlay && overlay.classList.add('open'); renderCart(); }
  function closeCart() { drawer && drawer.classList.remove('open'); overlay && overlay.classList.remove('open'); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); }
    if (e.target.closest('[data-cart-overlay]')) { closeCart(); }
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); mobMenu && mobMenu.classList.add('open'); }
    if (e.target.closest('[data-menu-close]')) { e.preventDefault(); mobMenu && mobMenu.classList.remove('open'); }
    var acc = e.target.closest('[data-acc-head]');
    if (acc) {
      var body = acc.parentElement.querySelector('[data-acc-body]');
      var sign = acc.querySelector('[data-acc-sign]');
      var isOpen = body.classList.contains('open');
      acc.parentElement.parentElement.querySelectorAll('[data-acc-body]').forEach(function (b) { b.classList.remove('open'); });
      acc.parentElement.parentElement.querySelectorAll('[data-acc-sign]').forEach(function (s) { s.classList.remove('open'); });
      if (!isOpen) { body.classList.add('open'); sign.classList.add('open'); }
    }
  });

  // add to cart (product form) via AJAX
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cart-form]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { openCart(); })
      .catch(function (err) { console.error(err); });
  });

  // qty +/- and remove inside drawer
  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      var key = qtyBtn.getAttribute('data-key');
      var delta = parseInt(qtyBtn.getAttribute('data-qty-change'), 10);
      var line = qtyBtn.closest('[data-cart-line]');
      var current = parseInt(line.getAttribute('data-qty'), 10) || 1;
      updateLine(key, Math.max(0, current + delta));
    }
    var rm = e.target.closest('[data-remove-line]');
    if (rm) { e.preventDefault(); updateLine(rm.getAttribute('data-key'), 0); }
  });

  function updateLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { renderCart(); });
  }

  function renderCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var itemsEl = document.querySelector('[data-cart-items]');
      var footEl = document.querySelector('[data-cart-foot]');
      var countEls = document.querySelectorAll('[data-cart-count]');
      countEls.forEach(function (el) { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? '' : 'none'; });
      if (!itemsEl) return;
      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="cart-empty"><div class="ce-title serif">Tu bolsa está vacía</div><p style="font-size:14px;">Aún no has añadido piezas.</p></div>';
        if (footEl) footEl.innerHTML = '';
        return;
      }
      var html = '';
      cart.items.forEach(function (it) {
        html += '<div class="cart-item" data-cart-line data-qty="' + it.quantity + '">' +
          '<div class="ci-media">' + (it.image ? '<img src="' + it.image + '" alt="">' : '') + '</div>' +
          '<div><div class="ci-name">' + it.product_title + '</div>' +
          '<div class="ci-meta">' + it.variant_title + '</div>' +
          '<div class="ci-qty"><button data-qty-change="-1" data-key="' + it.key + '">–</button><span>' + it.quantity + '</span><button data-qty-change="1" data-key="' + it.key + '">+</button></div></div>' +
          '<div><div class="ci-price">' + formatMoney(it.final_line_price) + '</div>' +
          '<button class="ci-remove" data-remove-line data-key="' + it.key + '">Quitar</button></div></div>';
      });
      itemsEl.innerHTML = html;
      var bundleEligible = cart.item_count >= 2;
      var footHtml = '';
      if (!bundleEligible) footHtml += '<div class="bundle-banner">Añade <strong>1 pieza más</strong> y obtén <strong>10% de descuento</strong> en tu bolsa.</div>';
      else footHtml += '<div class="bundle-banner" style="color:#1f7a48;">✓ Descuento por bundle aplicado en el carrito, según reglas configuradas.</div>';
      footHtml += '<div class="cart-line total"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
        '<a href="/checkout" class="btn-primary btn-block">Ir a pagar</a>' +
        '<div class="cart-note">Envío gratis sobre ' + formatMoney(6000000) + ' · Cambios dentro de 30 días</div>';
      if (footEl) footEl.innerHTML = footHtml;
    });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toLocaleString('es-CL');
    return '$' + amount;
  }

  document.addEventListener('DOMContentLoaded', renderCart);
})();
